import { saveItem } from "./LocalStorage";
import { logEvent } from "./Analytics";
export default class PersistingObservable {
    constructor(value, key, eventName, transform = value => value) {
        this.observers = [];
        this.data = value;
        this.transform = transform;
        this.key = key;
        this.analyticsKey = eventName;
    }
    get value() {
        return this.data;
    }
    set value(newValue) {
        if (newValue !== this.data) {
            this.data = newValue;
            this.notifyObservers();
            this.persist();
            this.logToAnalytics();
        }
    }
    observe(observer) {
        this.observers.push(observer);
    }
    persist() {
        saveItem(this.key, this.transform(this.data));
    }
    logToAnalytics() {
        logEvent(this.analyticsKey, { value: this.transform(this.value) });
    }
    notifyObservers() {
        this.observers.forEach(observer => observer(this.value));
    }
}
